const apiURL = process.env.REACT_APP_API_URL;
const URL = process.env.REACT_APP_SUB_DOMAIN; // تغییر نام متغیر
export const BASE_API_URL = apiURL;
export const API_URL_PORTAL_USER = `${apiURL}/portal/user`;
export const API_URL_PORTAL = `${apiURL}/portal`;
export const API_URL_FLEET = `${apiURL}/fleet/user`;
export const API_URL_COMMON = `${apiURL}/common`;
export const DOMAIN = `${URL}`;
